<section class="relative">
  <div class="mask-curve-top-div bg-anis"></div>
  <div class="bg-anis py-12">
    <div class="centered-with-padding flex flex-col gap-y-12">
      @if (data.title; as title) {
        <app-title [title]="title" class="text-center" size="h2" />
      }
      @if (data.items; as items) {
        <ul class="flex flex-col items-center gap-y-9 desk:flex-row desk:items-stretch desk:justify-around">
          @for (item of items; track item.image.link) {
            <li class="flex max-w-64 flex-col items-center gap-y-5">
              <div class="relative h-[150px] w-full">
                <app-image
                  [image]="item.image"
                  [isPriority]="!isImageInPreviousBlocks"
                  [keepAspectRatio]="true"
                  [pregenerationSize]="{ width: 256, height: 150, exact: 'always' }" />
              </div>
              <div>
                <span class="block text-center font-bold">{{ item.title }}</span>
                <span class="block text-center">{{ item.text }}</span>
              </div>
            </li>
          }
        </ul>
      }
      @let text = data.text;
      @let hasCta = data.cta.label;
      @if (text || hasCta) {
        <div class="flex flex-col items-center gap-y-5">
          @if (text) {
            <div class="text-center font-bold">{{ text }}</div>
          }
          @if (hasCta) {
            @let cta = data.cta;
            @let gtm = data.gtmConfigCta;
            <app-button
              (onButtonClick)="
                emitGtmEvent({
                  event: gtm?.event,
                  group: gtm?.group,
                  description: gtm?.description,
                  context: gtm?.context,
                  button_text_value: cta.label,
                  event_type: 'click',
                })
              "
              [label]="cta.label"
              [url]="cta.url"
              theme="WHITE" />
          }
        </div>
      }
    </div>
  </div>
  <div class="mask-curve-top-div bg-white"></div>
</section>
